// extracted by mini-css-extract-plugin
module.exports = {"filtreringsmeny":"Filtreringsmeny_filtreringsmeny__MMqmN","category":"Filtreringsmeny_category__APr1q","introduction":"Filtreringsmeny_introduction__rildD"};